export default __webpack_public_path__ + "static/media/information-line.d1f97439.svg";